import { Action, Dispatch } from 'redux';
import { quickStatusCommentApi } from '../../../apis';
import {
  fetchQuickStatusCommentsFailure,
  fetchQuickStatusCommentsSuccess,
  setLoadingComments,
} from './statusCommentsReducer';
import { AppState } from '../../../store/store';

export const fetchQuickStatusComments =
  () =>
  async (dispatch: Dispatch, getState: () => AppState): Promise<Action | void> => {
    if (!getState().statusComments.loadingComments) {
      await dispatch(setLoadingComments(true));
      return quickStatusCommentApi
        .getStatusComments()
        .then((comments) => {
          return dispatch(fetchQuickStatusCommentsSuccess(comments));
        })
        .catch(() => {
          return dispatch(fetchQuickStatusCommentsFailure());
        });
    }
    return Promise.resolve();
  };
